var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14H5C4.448 14 4 13.552 4 13C4 12.448 4.448 12 5 12H11C11.552 12 12 12.448 12 13C12 13.552 11.552 14 11 14Z",
    fill: "#282D37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9H3C2.448 9 2 8.552 2 8C2 7.448 2.448 7 3 7H13C13.552 7 14 7.448 14 8C14 8.552 13.552 9 13 9Z",
    fill: "#282D37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H1C0.448 4 0 3.552 0 3C0 2.448 0.448 2 1 2H15C15.552 2 16 2.448 16 3C16 3.552 15.552 4 15 4Z",
    fill: "#282D37"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.8314d49a.svg";
export { ForwardRef as ReactComponent };